<template>
  <ul>
    <li
        v-for="(button, i) in visibleButtons"
        :key="i">
      <base-button
          :icon="button.icon"
          :text="button.text"
          @click="button.func"/>
    </li>
  </ul>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';

export default {
  name: 'note-menu',
  components: {
    BaseButton,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  computed: {
    visibleButtons() {
      return this.buttons.filter(button => button.visible !== false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

ul {
  border-radius: 0.25rem;
  list-style: none;
  overflow: hidden;

  li {
    button {
      margin: 0 !important;
      border-radius: 0;
      width: 100%;
    }
  }
}
</style>
